// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"e21015e9","253":"029c71e1","506":"c7f75dfe","569":"55bc1161","596":"1df69c2c","710":"93e86692","780":"02e36b77","948":"df93d4a1","972":"5638b20d"}[chunkId] + ".chunk.js";
};